/** 表格页：让 el-table 高度跟随 .page-body 可视区域（Options API mixin） */
const TABLE_HEIGHT_INSET = 8;

export const tableAreaHeightMixin = {
    data() {
        return {
            table_area_height: 320,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.sync_table_area_height();
            const body = this.$el?.querySelector?.('.page-body');
            if (body && typeof ResizeObserver !== 'undefined') {
                this._table_area_ro = new ResizeObserver(() => this.sync_table_area_height());
                this._table_area_ro.observe(body);
            }
        });
    },
    beforeUnmount() {
        this._table_area_ro?.disconnect();
    },
    methods: {
        sync_table_area_height() {
            const body = this.$el?.querySelector?.('.page-body');
            const h = body?.clientHeight;
            if (h && h > 0) {
                this.table_area_height = Math.max(200, h - TABLE_HEIGHT_INSET);
            }
            this.$nextTick(() => this.relayout_table?.());
        },
    },
};
